<template>
    <eSesjaModal>
        <eSesjaModalHeader @close="closeModal">
            {{ $t("com.global.edit") }} {{ $t("com.discussion.discussion-profile") }}
        </eSesjaModalHeader>
        <eSesjaModalBody>
            <label class="esesja-modal__wraper__body__label">{{ $t("com.file.edit-announcement.name") }}</label>
            <section class="esesja-modal__row">
                <input class="esesja-modal__wraper__body__input" type="text" v-model="discussionProfile.name"
                    :placecholder="$t('com.file.edit-announcement.name')" />
            </section>
            <ErrorMessage v-if="showDuplicateNameError" :errorMsgs="[$t('com.discussion.profile.name-unique-error')]" />
            <section class="d-flex flex-column mt-3">
                <section class="checkbox-wrapper" @click="toggleDefaultStatus">
                    <CheckBoxButtonSingleUnchecked :value="1" :id="'discussion-profile-edit-default'"
                        :disable="discussionProfile.defaults && isDefaultOnLoading" :checked="discussionProfile.defaults" />
                    <label class="checkbox">{{ $t("com.discussion.profile.default") }}<span
                            v-if="discussionProfile.defaults && isDefaultOnLoading">*</span></label>
                </section>
                <section style="font-size: 12px; color: #7e7e7e;" v-if="discussionProfile.defaults && isDefaultOnLoading">
                    *{{ $t("com.discussion.profile.default-info") }}
                </section>
            </section>

        </eSesjaModalBody>
        <eSesjaModalFooter>
            <eSesjaModalButtonCancel @close="closeModal">
                {{ $t("com.global.cancel") }}
            </eSesjaModalButtonCancel>
            <eSesjaModalButtonSave :disabled="isSaveDisabled" @save="updateDiscussionProfile">
                {{ $t("com.global.save") }}
            </eSesjaModalButtonSave>
        </eSesjaModalFooter>
    </eSesjaModal>
</template>
<script charset="utf-8">
import DiscussionProfileService from "@/services/discussion.profile.service";
import AlertHelper from "@/helpers/alerts.helper.js";
import ErrorMessage from "@/components/BasicControls/ErrorMessage.vue";
import CheckBoxButtonSingleUnchecked from "../../../../BasicControls/CheckButtonSingleUnchecked.vue";

export default {
    name: "EditDiscussionProfile",
    components: {
        ErrorMessage,
        CheckBoxButtonSingleUnchecked
    },
    data() {
        return {
            discussionProfile: {
                id: null,
                name: "",
                defaults: false
            },
            isDefaultOnLoading: false
        };
    },
    computed: {
        selectedDiscussionProfile() {
            return this.$store.state.discussionProfileStore.selectedDiscussionProfile;
        },
        availableDiscussionProfiles() {
            return this.$store.state.discussionProfileStore.discussionProfiles;
        },
        normalizedName() {
            return this.normalizeName(this.discussionProfile.name);
        },
        showDuplicateNameError() {
            return this.normalizedName.length > 0 && this.availableDiscussionProfiles.some((item) => {
                if (item?.id === this.discussionProfile.id) {
                    return false;
                }

                return this.normalizeName(item?.name) === this.normalizedName;
            });
        },
        isSaveDisabled() {
            return this.discussionProfile.name.trim().length < 3 || this.showDuplicateNameError;
        }
    },
    mounted() {
        if (this.selectedDiscussionProfile !== null) {
            this.isDefaultOnLoading = this.selectedDiscussionProfile.defaults;
            this.discussionProfile.id = this.selectedDiscussionProfile.id;
            this.discussionProfile.name = this.selectedDiscussionProfile.name ?? "";
            this.discussionProfile.defaults = this.selectedDiscussionProfile.defaults ?? false;
        }
    },
    methods: {
        normalizeName(value) {
            if (value === undefined || value === null) {
                return "";
            }

            return value.toString().trim().toLocaleLowerCase();
        },
        toggleDefaultStatus() {
            if (this.discussionProfile.defaults && this.isDefaultOnLoading) {
                return;
            }
            this.discussionProfile.defaults = !this.discussionProfile.defaults;
        },
        closeModal() {
            this.$store.commit("setIsShowEditDiscussionProfileStatus", false);
        },
        async updateDiscussionProfile() {
            if (this.showDuplicateNameError || this.discussionProfile.id === null) {
                return;
            }

            try {
                this.$store.commit("showLoader");

                await DiscussionProfileService.Update(this.discussionProfile.id, {
                    name: this.discussionProfile.name.trim(),
                    defaults: this.discussionProfile.defaults
                });

                this.closeModal();
            } catch (e) {
                if (e.response !== undefined) {
                    const t = this.$swal.mixin(AlertHelper.errorToastElement());
                    t.fire(
                        AlertHelper.errorToastAlert(
                            this.$t("com.global.default-save-error"),
                            this.$t("com.global.error")
                        )
                    );
                }
            } finally {
                this.$store.commit("hideLoader");
            }
        }
    }
};
</script>
<style lang="scss">
.checkbox {
    font-weight: normal;
    font-size: 16px;
    line-height: 144%;
    color: #333956;
    margin-left: 12px;
    margin-bottom: 0px;
    padding-left: 24px;
    z-index: 0;
    cursor: pointer;
}

.checkbox-wrapper {
    display: flex;
    padding: 5px;
    float: left;
}
</style>
